/**
 * The order of the My Projects list: Active, then On Hold, then Completed, and
 * within each, the project something last happened on first (lastActivityAt
 * from /projects/mine). Projects with no activity yet go last in their group,
 * by name.
 */
const STATUS_RANK = { Active: 0, 'On Hold': 1, Completed: 2 };

const rankOf = (status) => STATUS_RANK[status] ?? 3;
const timeOf = (value) => {
    const t = value ? new Date(value).getTime() : NaN;
    return Number.isNaN(t) ? -Infinity : t;
};

export const sortByActivity = (projects = []) => [...projects].sort((a, b) => (
    rankOf(a.status) - rankOf(b.status)
    || timeOf(b.lastActivityAt) - timeOf(a.lastActivityAt)
    || String(a.name || '').localeCompare(String(b.name || ''))
));

export default sortByActivity;
